import React from "react";
import { Button } from "react-bootstrap";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const IconDivButton = ({ variant, icon, className, tooltip, onClick, disabled }) => {

  return (
    <>
      <Tippy content={tooltip} interactive={true} placement="bottom">

        <div>
          <Button variant={variant}
                  disabled={disabled}
                  className={className + " icon-button"}
                  role="button"
                  onClick={onClick}>
            <i className={"fas " + icon} />
          </Button>
        </div>
      </Tippy>
    </>
  );
};


export default IconDivButton;